import React, { Component } from 'react';
import { connect } from 'react-redux';
import IntlMessages from 'util/IntlMessages';
import { injectIntl, intlShape } from 'react-intl';
import { Card, CardBody, CardHeader, Button } from 'reactstrap';
import { sendMailResponse, getMailResponseData, resetResponseModals, addChatMessage } from 'actions/MailResponse';
import { addressString } from 'components/FormattedAddress';
import Moment from 'moment';
import ReportStatus from 'constants/ReportStatus';
import LoadingScreen from 'react-loading-screen';
import SweetAlert from 'react-bootstrap-sweetalert';
import CustomScrollbars from 'util/CustomScrollbars';

class MailResponse extends Component {
	constructor(props) {
		super(props);
		this.state = {
			message: ''
		};
		this.scrollviewRef;
	}

	componentDidMount() {
		this.props.getMailResponseData(this.props.match.params.reportId, this.props.match.params.responsekey);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.loading.sendMessage && !this.props.loading.sendMessage && !this.props.sendError) this.setState({ message: '' });
		if (prevProps.messages.length < this.props.messages.length) this.scrollviewRef.scrollTop(this.scrollviewRef.getScrollHeight());
	}

	sendMessage = () => {
		this.props.sendMailResponse(this.state.message, this.props.match.params.reportId, this.props.match.params.responsekey);
		this.props.addChatMessage(this.state.message);
	};

	renderMessageItem = ({ type, message, date, id }) => {
		const centerStyle = { fontSize: 10 };

		return (
			<div
				key={id}
				className={`d-flex flex-column mb-2 mx-3 ${type === 2 ? 'align-items-start' : type === 0 ? 'align-items-center' : 'align-items-end'}`}
				style={type === 0 ? centerStyle : {}}
			>
				<div
					className={`${
						type === 2
							? 'w-75 text-left border-bottom'
							: type === 0
							? 'w-60 text-center bg-grey text-white rounded p-2'
							: 'w-75 text-right border-bottom'
					}`}
				>
					<p className="mb-0">{message}</p>
					{type !== 0 && <small>{Moment(date).format('DD.MM.YYYY HH:mm')}</small>}
				</div>
			</div>
		);
	};

	render() {
		const {
			reportId,
			type,
			insertDate,
			address,
			status,
			description,
			organisation,
			loading,
			error,
			sendError,
			sendSuccess,
			messages,
			supTypeName // ----------------- Nur für Beschwerdemanagement RD ECK ---------------------
		} = this.props;

		const reportStatus = _.find(ReportStatus, { statusId: status });

		if (error)
			return (
				<main className="app-main-content-wrapper d-flex align-items-center justify-content-center">
					<p>
						<strong>{error}</strong>
					</p>
				</main>
			);

		return (
			<main className="app-main-content-wrapper d-flex align-items-center mt-4">
				<LoadingScreen
					loading={loading.getData}
					bgColor="#f1f1f1"
					spinnerColor="#2f75ba"
					textColor="#676767"
					logoSrc="assets/images/icon-meldoo.svg"
					text="Daten werden geladen..."
				>
					<div className="row" style={{ maxWidth: 600 }}>
						<div className="col-12">
							<Card>
								<CardHeader className="bg-blue text-white">
									<IntlMessages id="mailResponse.title" />
								</CardHeader>
								<CardBody>
									<div className="row">
										<div className="col-12">
											<p>
												<IntlMessages id="mailResponse.info" />
											</p>
										</div>
										<div className="col-12">
											<h3 />
											<div className="d-flex justify-content-between border-bottom pb-2 mb-2">
												<div>
													<strong>
														<IntlMessages id="report.props.reportId" />:
													</strong>
												</div>
												<div>{reportId}</div>
											</div>
											<div className="d-flex justify-content-between border-bottom pb-2 mb-2">
												<div>
													<strong>
														<IntlMessages id="report.props.responsible" />:
													</strong>
												</div>
												<div>{organisation}</div>
											</div>
											<div className="d-flex justify-content-between border-bottom pb-2 mb-2">
												<div>
													<strong>
														<IntlMessages id="report.props.insertDate" />:
													</strong>
												</div>
												<div>{Moment(insertDate).format('DD.MM.YYYY HH:mm')}</div>
											</div>
											{addressString({ address }) && (
												<div className="d-flex justify-content-between border-bottom pb-2 mb-2">
													<div>
														<strong>
															<IntlMessages id="report.props.address" />:
														</strong>
													</div>
													<div>{addressString({ address })}</div>
												</div>
											)}
											{supTypeName && (
												<div className="d-flex justify-content-between border-bottom pb-2 mb-2">
													<div>
														<strong>Art:</strong>
													</div>
													<div>{supTypeName}</div>
												</div>
											)}
											<div className="d-flex justify-content-between border-bottom pb-2 mb-2">
												<div>
													<strong>
														<IntlMessages id="report.props.type" />:
													</strong>
												</div>
												<div>{type}</div>
											</div>
											<div className="border-bottom pb-2 mb-2">
												<div className="mb-2">
													<strong>
														<IntlMessages id="report.props.description" />:
													</strong>
												</div>
												<div>{description}</div>
											</div>
											{reportStatus ? (
												<div className="d-flex justify-content-between border-bottom pb-2 mb-2">
													<div>
														<strong>
															<IntlMessages id="report.props.status.title" />:
														</strong>
													</div>
													<div>
														<IntlMessages id={reportStatus.textId} />
													</div>
												</div>
											) : null}
										</div>
										<div className="col-12">
											<strong>Nachrichtenverlauf:</strong>
											<div className="border rounded mt-2 py-2">
												<CustomScrollbars
													className="scrollbar"
													style={{
														height: 200
													}}
													onRef={ref => {
														this.scrollviewRef = ref;
													}}
												>
													{messages.map((message, index) => this.renderMessageItem(message))}
												</CustomScrollbars>
											</div>
										</div>
										<div className="col-12">
											<div className="form-group">
												<textarea
													className="form-control form-control-lg my-3"
													rows="5"
													placeholder={this.props.intl.formatMessage({
														id: 'mailResponse.placeholder'
													})}
													onChange={m =>
														this.setState({
															message: m.target.value
														})
													}
													value={this.state.message}
													maxLength={1000}
												/>
											</div>
										</div>
										<div className="col-12">
											<div className="d-flex mb-0">
												<Button
													color="default"
													className="jr-btn btn-blue btn jr-btn-sm right ml-auto"
													onClick={this.sendMessage}
													disabled={loading.sendMessage || !this.state.message}
												>
													{loading.sendMessage ? (
														<i className="zmdi zmdi-spinner zmdi-hc-spin" />
													) : (
														<i className="zmdi zmdi-mail-send" />
													)}
													<IntlMessages id="common.send" />
												</Button>
											</div>
										</div>
									</div>
								</CardBody>
							</Card>
						</div>
					</div>
					<footer className="app-footer">
						<div className="d-flex flex-row justify-content-between">
							<div>
								<span>
									&copy;{` ${Moment().year()} `}
									<a href="https://www.leanact.de/">leanact GmbH</a>. <IntlMessages id="footer.allRightsReserved" />.
								</span>
							</div>
							<div className="ml-3">
								<a href="https://www.leanact.de/impressum/">
									<IntlMessages id="impressum.title" />
								</a>
							</div>
							<div className="ml-3">
								<a href="https://www.leanact.de/agb-und-datenschutz/">
									<IntlMessages id="footer.dataprotection" />
								</a>
							</div>
						</div>
					</footer>
					<SweetAlert
						show={sendSuccess ? true : false}
						success
						title={<IntlMessages id="mailResponse.sendSuccess.title" />}
						onConfirm={this.props.resetResponseModals}
					>
						<IntlMessages id="mailResponse.sendSuccess.info" />
					</SweetAlert>
					<SweetAlert
						show={sendError ? true : false}
						warning
						title={<IntlMessages id="mailResponse.sendError.title" />}
						onConfirm={this.props.resetResponseModals}
					>
						{sendError}
					</SweetAlert>
				</LoadingScreen>
			</main>
		);
	}
}

function mapStateToProps({ mailResponse }) {
	const {
		loading,
		reportId,
		insertDate,
		address,
		type,
		status,
		description,
		organisation,
		error,
		sendError,
		sendSuccess,
		messages,
		supTypeName // ----------------- Nur für Beschwerdemanagement RD ECK ---------------------
	} = mailResponse;
	return { loading, reportId, insertDate, address, type, status, description, organisation, error, sendError, sendSuccess, supTypeName, messages };
}

export default connect(
	mapStateToProps,
	{ sendMailResponse, getMailResponseData, resetResponseModals, addChatMessage }
)(injectIntl(MailResponse));



// WEBPACK FOOTER //
// ./containers/MailResponse/index.js